/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const changeSlide = /* GraphQL */ `mutation ChangeSlide(
  $id: String!
  $url: String!
  $sequence: Float!
  $type: String!
  $pollId: String!
  $pollResults: [PollResultInput]
  $collateralTypeId: String
  $currentOffset: String
) {
  changeSlide(
    id: $id
    url: $url
    sequence: $sequence
    type: $type
    pollId: $pollId
    pollResults: $pollResults
    collateralTypeId: $collateralTypeId
    currentOffset: $currentOffset
  ) {
    id
    url
    sequence
    type
    pollId
    pollResults {
      option
      percentage
      voteCount
      __typename
    }
    collateralTypeId
    currentOffset
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ChangeSlideMutationVariables,
  APITypes.ChangeSlideMutation
>;
export const updateMeetingStatus = /* GraphQL */ `mutation UpdateMeetingStatus($eventid: String!, $meetingstatusflag: Boolean!) {
  updateMeetingStatus(
    eventid: $eventid
    meetingstatusflag: $meetingstatusflag
  ) {
    eventid
    meetingstatusflag
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMeetingStatusMutationVariables,
  APITypes.UpdateMeetingStatusMutation
>;
export const toggleSlideControl = /* GraphQL */ `mutation ToggleSlideControl(
  $eventid: String!
  $enableSlideControl: Boolean!
  $email: String
) {
  toggleSlideControl(
    eventid: $eventid
    enableSlideControl: $enableSlideControl
    email: $email
  ) {
    eventid
    enableSlideControl
    email
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ToggleSlideControlMutationVariables,
  APITypes.ToggleSlideControlMutation
>;
export const dragSlideForSequence = /* GraphQL */ `mutation DragSlideForSequence($eventid: String!, $isDragging: Boolean!) {
  dragSlideForSequence(eventid: $eventid, isDragging: $isDragging) {
    eventid
    isDragging
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DragSlideForSequenceMutationVariables,
  APITypes.DragSlideForSequenceMutation
>;
export const sendHostChatMessage = /* GraphQL */ `mutation SendHostChatMessage($input: HostChatMessageInput!) {
  sendHostChatMessage(input: $input) {
    id
    webinarId
    senderId
    senderName
    senderEmail
    senderRole
    channel
    targetUserId
    targetUserName
    message
    createdAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SendHostChatMessageMutationVariables,
  APITypes.SendHostChatMessageMutation
>;
export const askQuestion = /* GraphQL */ `mutation AskQuestion($input: AskQuestionInput!) {
  askQuestion(input: $input) {
    id
    webinarId
    askerId
    askerName
    askerRole
    body
    isAnonymous
    status
    isPinned
    isHighlighted
    isPublic
    upvoteCount
    answers {
      id
      responderId
      responderName
      responderEmail
      responderRole
      body
      isLiveAnswer
      createdAt
      __typename
    }
    answeredBy
    answeredByName
    answerType
    createdAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AskQuestionMutationVariables,
  APITypes.AskQuestionMutation
>;
export const upvoteQuestion = /* GraphQL */ `mutation UpvoteQuestion($input: QuestionActionInput!) {
  upvoteQuestion(input: $input) {
    id
    webinarId
    askerId
    askerName
    askerRole
    body
    isAnonymous
    status
    isPinned
    isHighlighted
    isPublic
    upvoteCount
    answers {
      id
      responderId
      responderName
      responderEmail
      responderRole
      body
      isLiveAnswer
      createdAt
      __typename
    }
    answeredBy
    answeredByName
    answerType
    createdAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpvoteQuestionMutationVariables,
  APITypes.UpvoteQuestionMutation
>;
export const answerQuestion = /* GraphQL */ `mutation AnswerQuestion($input: AnswerQuestionInput!) {
  answerQuestion(input: $input) {
    id
    webinarId
    askerId
    askerName
    askerRole
    body
    isAnonymous
    status
    isPinned
    isHighlighted
    isPublic
    upvoteCount
    answers {
      id
      responderId
      responderName
      responderEmail
      responderRole
      body
      isLiveAnswer
      createdAt
      __typename
    }
    answeredBy
    answeredByName
    answerType
    createdAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AnswerQuestionMutationVariables,
  APITypes.AnswerQuestionMutation
>;
export const dismissQuestion = /* GraphQL */ `mutation DismissQuestion($input: QuestionActionInput!) {
  dismissQuestion(input: $input) {
    id
    webinarId
    askerId
    askerName
    askerRole
    body
    isAnonymous
    status
    isPinned
    isHighlighted
    isPublic
    upvoteCount
    answers {
      id
      responderId
      responderName
      responderEmail
      responderRole
      body
      isLiveAnswer
      createdAt
      __typename
    }
    answeredBy
    answeredByName
    answerType
    createdAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DismissQuestionMutationVariables,
  APITypes.DismissQuestionMutation
>;
export const deleteQuestion = /* GraphQL */ `mutation DeleteQuestion($input: QuestionActionInput!) {
  deleteQuestion(input: $input) {
    id
    webinarId
    askerId
    askerName
    askerRole
    body
    isAnonymous
    status
    isPinned
    isHighlighted
    isPublic
    upvoteCount
    answers {
      id
      responderId
      responderName
      responderEmail
      responderRole
      body
      isLiveAnswer
      createdAt
      __typename
    }
    answeredBy
    answeredByName
    answerType
    createdAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteQuestionMutationVariables,
  APITypes.DeleteQuestionMutation
>;
export const publishQuestion = /* GraphQL */ `mutation PublishQuestion($input: QuestionActionInput!) {
  publishQuestion(input: $input) {
    id
    webinarId
    askerId
    askerName
    askerRole
    body
    isAnonymous
    status
    isPinned
    isHighlighted
    isPublic
    upvoteCount
    answers {
      id
      responderId
      responderName
      responderEmail
      responderRole
      body
      isLiveAnswer
      createdAt
      __typename
    }
    answeredBy
    answeredByName
    answerType
    createdAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.PublishQuestionMutationVariables,
  APITypes.PublishQuestionMutation
>;
export const toggleCustomChatQna = /* GraphQL */ `mutation ToggleCustomChatQna(
  $eventid: String!
  $enableCustomChatQna: Boolean!
) {
  toggleCustomChatQna(
    eventid: $eventid
    enableCustomChatQna: $enableCustomChatQna
  ) {
    eventid
    enableCustomChatQna
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ToggleCustomChatQnaMutationVariables,
  APITypes.ToggleCustomChatQnaMutation
>;
